/**
 * * Item de Lista.
 */
export class ItemList {

  constructor(
    /**
     * * Identificador do item.
     */
    public id?: string,
    /**
     * * Item selecionado.
     */
    public selected?: boolean,
    /**
     * * Título do item.
     */
    public title?: string,
    /**
     * * Descrição do item.
     */
    public description?: string
  ) {}

}
